import type FaqStrapi from "~/libs/interfaces/FaqStrapi";
import type FaqLocal from "~/libs/interfaces/FaqLocal";

const faqLocalFactory = {
  createFaqFromStrapi(faq?: FaqStrapi): FaqLocal | undefined {
    if (!faq) {
      return undefined;
    }
    return {
      id: faq.id,
      documentId: faq.documentId,

      createdAt: faq.createdAt ? new Date(faq.createdAt) : undefined,
      updatedAt: faq.updatedAt ? new Date(faq.updatedAt) : undefined,
      publishedAt: faq.publishedAt ? new Date(faq.publishedAt) : undefined,

      question: faq.question,
      answer: faq.answer,
      isVisible: faq.isVisible,
      order: faq.order || 1,
    }
  }
}
export default faqLocalFactory